import { Box, ContentBlock, Page } from 'braid-design-system';
import type { FC, ReactElement } from 'react';

interface PageLayoutProps {
  header: ReactElement;
  body: ReactElement;
  footer: ReactElement;
}

export const PageLayout: FC<PageLayoutProps> = ({ header, body, footer }) => (
  <Page footer={footer}>
    {header}
    <Box
      paddingTop="xlarge"
      paddingX={['small', 'medium', 'xxlarge']}
      paddingBottom={['xlarge', 'xxxlarge']}
    >
      <ContentBlock width="large">{body}</ContentBlock>
    </Box>
  </Page>
);
